import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export default function HangerIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon viewBox={'0 0 40.69 36.89'} fontSize={'inherit'} {...props}>
      <g id="Calque_1-2" data-name="Calque 1">
        <path
          className="cls-1"
          d="m39.95,29.4l-18-14.1v-1c1.63-.47,3-1.33,4.1-2.6,1.1-1.27,1.65-2.75,1.65-4.45,0-2.03-.72-3.75-2.15-5.15-1.43-1.4-3.17-2.1-5.2-2.1s-3.76.72-5.17,2.15c-.81.82-1.39,1.74-1.74,2.76-.4,1.19.47,2.44,1.73,2.44.79,0,1.48-.52,1.73-1.27.17-.5.46-.95.85-1.36.7-.72,1.57-1.08,2.6-1.08s1.91.36,2.62,1.08,1.07,1.59,1.08,2.62c0,.98-.39,1.93-1.09,2.62-.74.72-1.62,1.07-2.66,1.04-.5,0-.92.18-1.25.55-.33.37-.5.8-.5,1.3v2.55L.75,29.4c-.7.57-.91,1.25-.62,2.05s.86,1.2,1.72,1.2h11.26c-.7-1.1-1.06-2.26-1.06-3.47,0-.06.01-.12.02-.18h-4.72l13-10.4,13.05,10.4h-4.79c0,.06.02.12.02.18,0,1.21-.36,2.37-1.07,3.47h11.29c.72,0,1.4-.41,1.67-1.08.36-.88.17-1.61-.57-2.17Z"
        />
        <path
          className="cls-2"
          d="m20.33,36.89c-.14,0-.27-.02-.4-.07-.13-.04-.25-.12-.35-.22l-.82-.77c-1.16-1.07-2.17-2.1-3.04-3.1-.87-1-1.3-2.07-1.3-3.2,0-.92.31-1.68.93-2.3.62-.62,1.38-.92,2.27-.92.51,0,.99.12,1.46.35.47.23.89.58,1.25,1.05.41-.47.83-.82,1.27-1.05.44-.23.92-.35,1.43-.35.9,0,1.67.31,2.28.92.62.62.93,1.38.93,2.3,0,1.14-.44,2.2-1.31,3.21-.87,1-1.88,2.03-3.01,3.09l-.84.78c-.1.11-.22.18-.35.22-.13.04-.26.06-.4.06Z"
        />
      </g>
    </SvgIcon>
  );
}
